import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=a6dbbad6&scoped=true&"
import script from "./Dealers.vue?vue&type=script&lang=js&"
export * from "./Dealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dbbad6",
  null
  
)

export default component.exports